import { useEffect } from 'react'
import useNewDesign from '../hooks/useNewDesign'

// Sets body.new-design while the new design is on, so stylesheets can restyle old screens
// (redesign round 1) without touching their components.
export default function NewDesignBodyClass() {
  const enabled = useNewDesign()
  useEffect(() => {
    document.body.classList.toggle('new-design', enabled)
    return () => { document.body.classList.remove('new-design') }
  }, [enabled])
  return null
}
